import type { SelectOption } from '../types';

interface SelectedValueProps {
  option: SelectOption | null;
  placeholder?: string;
}

export const SelectedValue = ({ option, placeholder }: SelectedValueProps) => {
  if (!option) {
    return <>{placeholder}</>;
  }

  return (
    <div className="flex items-center gap-3 ml-2">
      <span className="text-gray-800 font-medium text-ellipsis overflow-hidden whitespace-nowrap flex-1 min-w-0">
        {option.label}
      </span>
      {option.avatar && (
        <img
          src={option.avatar}
          alt={option.label}
          className="w-6 h-6 rounded-full flex-shrink-0 object-cover"
        />
      )}
      {option.additionalInfo && <div className="flex-shrink-0">{option.additionalInfo}</div>}
    </div>
  );
};
